import { render, staticRenderFns } from "./CancelModal.vue?vue&type=template&id=a2b3faa6&"
import script from "./CancelModal.vue?vue&type=script&lang=js&"
export * from "./CancelModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports